export default {
  productName: 'Serviso v-1.0',
  serverBasePath: 'https://yrb-services.undash-cop.com',
  currencySymbol: '₹',
  userTypes: ['Admin', 'Employee', 'Sales', 'Developer']
};
